module.exports = __webpack_public_path__ + "static/superdrug-mobile-card-765e11f67fdec2348cead269c851c69c.jpg";